import SelfEnterpriseDetails from "./SelfEnterpriseDetails";

export default SelfEnterpriseDetails;
